export default __webpack_public_path__ + "746d2443de67ecd5bd834c6126c93e27.svg";